import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useUser } from "../../../../../AuthContext";
import { IRootState } from "../../../../../reducer/CombineReducer";
import { OutputConfigSlice } from "../../redux";
import { BandModeType } from "../Types";
import { getDataForEdit, getUpdatedFeatureDetails } from "./Data";
import { BandingEthnicityFormView } from "./BandingEthnicityForm.view";

interface BandingEthnicityFormProps {
  /**
   * Onchange for Band name
   */
  onChange?: (name: string) => void;
  /**
   * Onchange for Band name
   */
  onFilterChange?: (selectedFilter: string) => void;
  /**
   * Entered banding name in textfield
   */
  bandingName: string;
}

/**
 * Responsible for rendering ethnicity banding popup
 * @returns Ethnicity banding popup view
 */
export const BandingEthnicityForm: React.FC<BandingEthnicityFormProps> = (props: BandingEthnicityFormProps) => {
  const { user } = useUser();
  const dispatch = useDispatch();
  const outputConfig = useSelector((state: IRootState) => state.outputConfig);
  const { definition, bandMode, ethnicityCategory } = outputConfig.selectedBandingDetails;
  const entryDataForDetails = outputConfig.entryData;
  const [isDataLoaded, setDataLoaded] = React.useState(false);

  useEffect(() => {
    if (bandMode === BandModeType.EDIT) {
      const data = getDataForEdit(definition as string);
      dispatch(OutputConfigSlice.actions.setEntryData(data));
    }
  }, [bandMode]);

  useEffect(() => {
    if (bandMode === BandModeType.EDIT && !isDataLoaded) {
      const activePill = document.querySelector(".qbl-pill__text") as HTMLElement;
      if (activePill) {
        activePill.click();
        setDataLoaded(true);
      }
    }
  }, [entryDataForDetails]);

  /**
   * Method for handling update
   * @param ruleEntry contains entry and feature detail
   */
  const onUpdate = (ruleEntry: any): void => {
    dispatch(OutputConfigSlice.actions.setEntryData(ruleEntry));
  };

  /**
   * Handler for gender and ethinicity onchange
   * @param val updated value
   */
  const handleNameChange = (e: React.SyntheticEvent<HTMLInputElement | HTMLTextAreaElement>): void => {
    if (props.onChange)
      props.onChange(e.target["value"]);
  };

  /**
   * Handler for filter change
   * @param selectedFilter currently selected filter
   */
  const handleFilterChange = (selectedFilter: string): void => {
    if (props.onFilterChange)
      props.onFilterChange(selectedFilter);
  };

  return (
    <BandingEthnicityFormView
      bandName={props.bandingName}
      onChange={handleNameChange}
      onUpdate={onUpdate}
      entry={entryDataForDetails}
      featureDetails={getUpdatedFeatureDetails(entryDataForDetails)}
      token={user.token}
      onFilterChange={handleFilterChange}
      ethnicityCategory={ethnicityCategory as string}
    />
  );
};
